import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCoffee = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={25} height={25} fill='none' {...props}>
    <g strokeLinecap='round' strokeLinejoin='round' strokeWidth={1.5}>
      <path
        stroke='#9575CD'
        d='M18.04 10.97v7.32a4.21 4.21 0 0 1-4.21 4.21H6.46c-2.32 0-4.21-1.89-4.21-4.21v-7.32a4.21 4.21 0 0 1 4.21-4.21h7.37c2.32 0 4.21 1.89 4.21 4.21'
      />
      <path
        stroke='currentColor'
        d='M5.75 4.5V2.75M9.75 4.5V2.75M13.75 4.5V2.75M22.25 13.66c0 2.32-1.89 4.21-4.21 4.21V9.45a4.21 4.21 0 0 1 4.21 4.21M2.25 12.5h15.51'
      />
    </g>
  </svg>
);
export default SvgCoffee;
